<template>
  <div v-if="isInstructorMobile">
    <InstructorMobile />
  </div>
  <div v-else class="full-height">
    <div v-if="!loading && !horsesLoading" class="full-height">
      <div 
        class="relative white-bg"
        :class="{ 'z3 sessions': !isRepriseTab }"
      >
        <div 
          v-if="isRepriseTab"
          id="mainPlanner"
        >
          <ReprisePlanner />
        </div>
        <MainPlanner v-else />
      </div>
      <div 
        class="light-grey-bg"
        :class="!isRepriseTab ? 'pa-4 inner_remaining' : 'full-height'"
      >
        <Tabs class="full-height" />

        <div v-if="canShowScrollButton" class="fixed right-0 bottom-5 full-height d-flex align-end mr-4">
          <div class="d-flex justify-end">
            <v-btn
              class="mx-2"
              fab
              dark
              color="third"
              @click="scrollToTop"
            >
              <v-icon dark>
                mdi-arrow-up-bold
              </v-icon>
            </v-btn>
          </div>
        </div>
      </div>
    </div>

    <div v-else class="d-flex justify-center align-center full-height">
      <Loader />
    </div>

    <SessionDetailPopIn />
    <RecurringSessionModal />
    <SelectParticipantModal />
    <HorseAssignList v-if="showHorseAssignList" />
    <ParticipantHorseHistory v-if="showParticipantHorseHistory" />
    <MaxEffortConfirmation />
    <DailySoinsWarningModal v-if="showDailySoinsWarning" v-model="showDailySoinsWarning" :items="dailySoinsModalItems" @closeModal="showDailySoinsWarning = false" />
  </div>
</template>

<script>
import { ref, computed, provide, onBeforeMount } from '@vue/composition-api';

import store from '@/store';

import Loader from '@/components/common/Loader.vue';

import Tabs from '@/components/planner/Tabs.vue';
import MainPlanner from '@/components/planner/MainPlanner.vue';
import InstructorMobile from '@/components/instructor/InstructorMobile.vue';
import SessionDetailPopIn from '@/components/sessions/SessionDetailPopIn.vue';
import RecurringSessionModal from '@/components/planner/RecurringSessionModal.vue';
import SelectParticipantModal from '@/components/ParticipantHorse/SelectParticipantModal.vue';
import HorseAssignList from '@/components/planner/HorseAssignList.vue';
import ParticipantHorseHistory from '@/components/planner/ParticipantHorseHistory.vue';
import MaxEffortConfirmation from '@/components/horse/MaxEffortConfirmation.vue';
import DailySoinsWarningModal from '@/components/horse/DailySoinsWarningModal.vue';

import ReprisePlanner from '@/components/reprises/planner/ReprisePlanner.vue';


export default {
  components: {
    Loader,
    Tabs,
    MainPlanner,
    RecurringSessionModal,
    InstructorMobile,
    SelectParticipantModal,
    HorseAssignList,
    ParticipantHorseHistory,
    MaxEffortConfirmation,
    DailySoinsWarningModal,
    ReprisePlanner,
    SessionDetailPopIn
  },
  setup () {
    const canShowScrollButton = ref(false);

    const showHorseAssignList = ref(false);
    const showParticipantHorseHistory = ref(false);
    const disableAll = ref(true);
    const selectedSession = ref(null);
    const selectedParticipant = ref(null);

    // select Participant
    const showParticipantModal = ref(false);
    const selectParticipantModalData = ref(null);

    const showDailySoinsWarning = ref(false);
    const dailySoinsModalItems = ref([]);
    const horsesLoading = ref(false);

    const loading = computed(() => store.state.loading);
    const isRepriseTab = computed(() => store.state.currentTab === 'reprise');
    const isInstructorMobile = computed(() => store.getters.isIntructorOnMobile);

    provide('showParticipantModal', showParticipantModal);
    provide('selectParticipantModalData', selectParticipantModalData);
    provide('showHorseAssignList', showHorseAssignList);
    provide('showParticipantHorseHistory', showParticipantHorseHistory);
    provide('disableAll', disableAll);
    provide('selectedSession', selectedSession);
    provide('selectedParticipant', selectedParticipant);

    /* HELPERS */
    const scrollToTop = () => {
      const elem = document.getElementById('contentTypeCalendar');

      elem.scrollTop = 0;
    };


    onBeforeMount(async () => {
      if (!store.state.firstLoad) {
        return;
      }
      store.commit('setFirstLoad', false);

      const dailySoinsWithHorses = (store.getters.dailySoins || []).filter(s => (s.horses || []).length);
      if (!dailySoinsWithHorses.length) {
        return;
      }

      if (!store.state.horses.length) {
        horsesLoading.value = true;
        await store.dispatch('getHorses');
        horsesLoading.value = false;
      }

      dailySoinsModalItems.value = dailySoinsWithHorses;
      showDailySoinsWarning.value = true;
    });

    return {
      showParticipantHorseHistory,
      showHorseAssignList,
      loading,
      isRepriseTab,
      /* planner */
      scrollToTop,
      canShowScrollButton,
      isInstructorMobile,
      showDailySoinsWarning,
      dailySoinsModalItems,
      horsesLoading
    };
  }
};
</script>

<style>
.sessions {
  height: 200px;
}

.inner_remaining {
  flex-grow : 1;
  height:calc(100vh - 264px);
}

.v-application ul, .v-application ol{
  padding-left: 0 !important;
}
</style>
